import { createStore } from "vuex";
import { config } from "vuex-module-decorators";

import AuthModule from "@/store/modules/AuthModule";
import BodyModule from "@/store/modules/BodyModule";
import ConfigModule from "@/store/modules/ConfigModule";
import ThemeModeModule from "@/store/modules/ThemeModeModule";
import DocumentModule from "@/store/modules/Document/DocumentModule";
import DocumentDetailModule from "@/store/modules/Document/DocumentDetailModule";
import VideoModule from "@/store/modules/Video/VideoModule";
import VideoDetailModule from "@/store/modules/Video/VideoDetailModule";
import FieldDocumentsModule from "@/store/modules/FieldDocumentsModule";
import FieldDocumentDetailModule from "@/store/modules/FieldDocumentDetailModule";
import NewsContentModule from "@/store/modules/NewsContentModule";
import NewsContentDetailModule from "@/store/modules/NewsContentDetailModule";
import MenuModule from "@/store/modules/Menu/MenuModule";
import AgencyIssuedDocumentsModule from "@/store/modules/AgencyIssuedDocumentsModule";
import AgencyIssuedDocumentDetailModule from "@/store/modules/AgencyIssuedDocumentDetailModule";
import TypeDocumentsModule from "@/store/modules/TypeDocumentsModule";
import TypeDocumentDetailModule from "@/store/modules/TypeDocumentDetailModule";
import LeadersModule from "@/store/modules/LeadersModule";
import LeaderDetailModule from "@/store/modules/LeaderDetailModule";
import DepartmentsModule from "@/store/modules/DepartmentsModule";
import DepartmentDetailModule from "@/store/modules/DepartmentDetailModule";
import PositionModule from "@/store/modules/PositionModule";
import PublicationsManagesModule from "@/store/modules/PublicationsManagesModule";
import PublicationsManageDetailModule from "@/store/modules/PublicationsManageDetailModule";
import YearbooksModule from "@/store/modules/YearbooksModule";
import YearbookDetailModule from "@/store/modules/YearbookDetailModule";
import CategoryYearbooksModule from "@/store/modules/CategoryYearbooksModule";
import CategoryYearbookDetailModule from "@/store/modules/CategoryYearbookDetailModule";
import NotificationModule from "@/store/modules/Notification/NotificationModule";
import TargetYearbooksModule from "@/store/modules/Yearbooks/TargetYearbooksModule";
import TargetYearbookDetailModule from "@/store/modules/Yearbooks/TargetYearbookDetailModule";
import NotificationDetailModule from "@/store/modules/Notification/NotificationDetailModule";
import NewNotificationModule from "@/store/modules/Notification/NewNotificationModule";
import ReportKtxhsModule from "@/store/modules/ReportKtxhsModule";
import ReportKtxhDetailModule from "@/store/modules/ReportKtxhDetailModule";
import ConfigInfoModule from "@/store/modules/Config/ConfigModule";
import CheDoBaoCaoModule from "@/store/modules/CheDoThongBao/CheDoBaoCaoModule";
import CheDoBaoCaoDetailModule from "@/store/modules/CheDoThongBao/CheDoBaoCaoDetailModule";

import ManagerModule from "@/store/modules/Manager/ManagerModule";
import ManagerGroupModule from "@/store/modules/Manager/ManagerGroupModule";
import ConfigApiModule from "@/store/modules/ConfigAPi/ConfigModule";
import RoleModule from "@/store/modules/Manager/RoleModule";
import FeedbackModule from "@/store/modules/Feedback/FeedbackModule";
import FeedbackDetailModule from "@/store/modules/Feedback/FeedbackDetailModule";
import ActivityLogsModule from "@/store/modules/ActivityLogs/ActivityLogsModule";
import SignUpServiceModule from "@/store/modules/Statistical/SignUpServiceModule";
import StatisticalServiceModule from "@/store/modules/Statistical/StatisticalServiceModule";

import BannerModule from "@/store/modules/Display/BannerModule";
import LichPhoBienDetailModule from "@/store/modules/Stats/LichPhoBienDetailModule";
import LichPhoBiensModule from "@/store/modules/Stats/LichPhoBiensModule";
import BaoCaoSLTKDetailModule from "@/store/modules/Stats/BaoCaoSLTKDetailModule";
import BaoCaoSLTKsModule from "@/store/modules/Stats/BaoCaoSLTKsModule";
import InternalNotificationsModule from "@/store/modules/internal/InternalNotificationsModule";
import InternalNotificationDetailModule from "@/store/modules/internal/InternalNotificationDetailModule";
import InternalNotificationsByManagerModule from "@/store/modules/internal/InternalNotificationsByManagerModule";
import InternalNotificationByManagerDetailModule from "@/store/modules/internal/InternalNotificationByManagerDetailModule";

import InternalDocumentModule from "@/store/modules/InternalDocument/InternalDocumentModule";
import InternalDocumentDetailModule from "@/store/modules/InternalDocument/InternalDocumentDetailModule";
import InternalDocumentByManagerModule from "@/store/modules/InternalDocument/InternalDocumentByManagerModule";
import InternalDocumentByManagerDetailModule from "@/store/modules/InternalDocument/InternalDocumentByManagerDetailModule";
import CuocDieuTraModule from "@/store/modules/CheDoThongBao/CuocDieuTraModule";
import CuocDieuTraDetailModule from "@/store/modules/CheDoThongBao/CuocDieuTraDetailModule";
import DistrictsModule from "@/store/modules/Districts/DistrictsModule";
import CuocDieuTraApiModule from "@/store/modules/CheDoThongBao/CuocDieuTraApiModule";
import CuocDieuTraApiDetailModule from "@/store/modules/CheDoThongBao/CuocDieuTraApiDetailModule";
import ProgressModule from "@/store/modules/InfoCollection/ProgressModule";
import SurveyModule from "@/store/modules/Surveys/SurveyModule";
import SurveyDetailModule from "@/store/modules/Surveys/SurveyDetailModule";
import PhanToModule from "@/store/modules/PhanToModule";
import LinhVucDieuTraModule from "@/store/modules/Gis/LinhVucDieuTra/LinhVucDieuTraModule";
import GisConfigModule from "@/store/modules/Gis/Config/GisConfigModule";
import GisImportModule from "@/store/modules/Gis/Import/ImportModule";
import SubsiteConfigModule from "@/store/modules/SubsiteConfig/SubsiteConfigModule";

import DanhMucChiTieuModule from "@/store/modules/Gis/DanhMucChiTieu/DanhMucChiTieuModule";
import LinhVucDieuTraSearchModule from "@/store/modules/Gis/DanhMucChiTieu/LinhVucDieuTraModule";
import CommuneModule from "@/store/modules/Map/Commune/CommuneModule";
import CommuneDetailModule from "@/store/modules/Map/Commune/CommuneDetailModule";
import DmTinhModule from "@/store/modules/Gis/DmTinh/DmTinhModule";
import DmHuyenModule from "@/store/modules/Gis/DmHuyen/DmHuyenModule";
import CuocDieuTraGisModule from "@/store/modules/Map/CuocDieuTra/CuocDieuTraGisModule";
import CuocDieuTraGisDetailModule from "@/store/modules/Map/CuocDieuTra/CuocDieuTraGisDetailModule";
import LinkedWebsiteDetailModule from "@/store/modules/Display/LinkedWebsiteDetailModule";
import LinkedWebsiteModule from "@/store/modules/Display/LinkedWebsiteModule";
import ChiTieuThongKesModule from "@/store/modules/Stats/ChiTieuThongKesModule";
import ChiTieuThongkeDetailModule from "@/store/modules/Stats/ChiTieuThongKeDetailModule";
import DuLieuChiTieuDetailModule from "@/store/modules/Stats/DuLieuChiTieuDetailModule";
import DuLieuChiTieusModule from "@/store/modules/Stats/DuLieuChiTieusModule";
import IntroduceDetailModule from "@/store/modules/Introduce/IntroduceDetailModule";

import DieutrathongkeModule from "@/store/modules/Display/DieutrathongkeModule";

config.rawError = true;

const store = createStore({
  modules: {
    AuthModule,
    BodyModule,
    ConfigModule,
    ThemeModeModule,
    DocumentModule,
    DocumentDetailModule,
    VideoModule,
    VideoDetailModule,
    FieldDocumentsModule,
    FieldDocumentDetailModule,
    NewsContentModule,
    NewsContentDetailModule,
    MenuModule,
    AgencyIssuedDocumentsModule,
    AgencyIssuedDocumentDetailModule,
    TypeDocumentsModule,
    TypeDocumentDetailModule,
    LeadersModule,
    LeaderDetailModule,
    DepartmentsModule,
    DepartmentDetailModule,
    PositionModule,
    PublicationsManagesModule,
    PublicationsManageDetailModule,
    YearbooksModule,
    YearbookDetailModule,
    CategoryYearbooksModule,
    CategoryYearbookDetailModule,
    ManagerModule,
    ConfigApiModule,
    ManagerGroupModule,
    RoleModule,
    NotificationModule,
    TargetYearbooksModule,
    TargetYearbookDetailModule,
    NotificationDetailModule,
    ReportKtxhsModule,
    ReportKtxhDetailModule,
    NewNotificationModule,
    ConfigInfoModule,
    FeedbackModule,
    FeedbackDetailModule,
    ActivityLogsModule,
    SignUpServiceModule,
    BannerModule,
    CheDoBaoCaoModule,
    CheDoBaoCaoDetailModule,
    LichPhoBienDetailModule,
    LichPhoBiensModule,
    BaoCaoSLTKDetailModule,
    BaoCaoSLTKsModule,
    StatisticalServiceModule,
    InternalDocumentModule,
    InternalDocumentDetailModule,
    InternalDocumentByManagerModule,
    InternalDocumentByManagerDetailModule,
    InternalNotificationsModule,
    InternalNotificationDetailModule,
    InternalNotificationsByManagerModule,
    InternalNotificationByManagerDetailModule,
    CuocDieuTraModule,
    CuocDieuTraDetailModule,
    DistrictsModule,
    CuocDieuTraApiModule,
    CuocDieuTraApiDetailModule,
    ProgressModule,
    SurveyModule,
    SurveyDetailModule,
    PhanToModule,
    DanhMucChiTieuModule,
    LinhVucDieuTraSearchModule,
    LinhVucDieuTraModule,
    CommuneModule,
    CommuneDetailModule,
    DmTinhModule,
    DmHuyenModule,
    GisConfigModule,
    CuocDieuTraGisModule,
    CuocDieuTraGisDetailModule,
    GisImportModule,
    SubsiteConfigModule,
    LinkedWebsiteModule,
    LinkedWebsiteDetailModule,
    ChiTieuThongKesModule,
    ChiTieuThongkeDetailModule,
    DuLieuChiTieuDetailModule,
    DuLieuChiTieusModule,
    IntroduceDetailModule,
    DieutrathongkeModule,
  },
});

export default store;
